import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=17ccc199&"
import script from "./Paginate.vue?vue&type=script&lang=ts&"
export * from "./Paginate.vue?vue&type=script&lang=ts&"
import style0 from "./Paginate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports